import React, { useCallback } from 'react';
import { DesignSystemsIntlProvider } from './DesignSystemsIntlProvider';
import { EnterpriseIntlProvider } from '@enterprise/common';
import enMessages from '../../lang/compiled/en.intl.output.json';
import { messageLoaders } from './utils';

interface IntlProviderProps {
  messages?: Record<string, string>;
}

export const IntlProvider: React.FC<React.PropsWithChildren<IntlProviderProps>> = ({ children, messages }) => {
  const getMessages = useCallback((lang: string) => {
    return messageLoaders[lang]?.() ?? Promise.resolve({});
  }, []);

  return (
    <>
      <EnterpriseIntlProvider messages={messages ?? enMessages} getMessages={getMessages}>
        <DesignSystemsIntlProvider>{children}</DesignSystemsIntlProvider>
      </EnterpriseIntlProvider>
    </>
  );
};
